import Vue from 'vue'
import VueRouter from 'vue-router'
import all from './modules/index'

Vue.use(VueRouter)

const routes = [
  ...all
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  setTimeout(function() {
    document.documentElement.scrollTop=1;
    document.body.scrollTop=1;
  }, 1);
  
  if(to.meta.title) document.title = to.meta.title;
  next();
})

router.afterEach((to, from, next) => {
  setTimeout(function() {
    document.documentElement.scrollTop=1;
    document.body.scrollTop=1;
  }, 1);
  //判断是否为着陆页
  if (navigator.userAgent.toLowerCase().indexOf('iphone') !== -1 && !sessionStorage.getItem('landingUrl')) {
    sessionStorage.setItem('landingUrl', window.location.href);
  }
});

export default router
